import React, { FC } from "react";
import { Upload2Icon } from "@/icons/primary-icons-new";

type Props = {
  currFile: File[] | File | null;
  uploaded: boolean;
  typeError: boolean;
  disabled: boolean | undefined;
  label: string | undefined;
  maxSize?: number;
  types?: string[];
};

const Description: FC<Props> = ({
  currFile,
  uploaded,
  typeError,
  disabled,
  label,
  maxSize,
  types,
}) => {
  if (typeError)
    return (
      <Wrapper maxSize={maxSize} types={types}>
        <div className='text-lg font-semibold mt-5'>File type/size error, hovered on types!</div>
      </Wrapper>
    );

  if (disabled)
    return (
      <Wrapper maxSize={maxSize} types={types}>
        <div className='text-lg font-semibold mt-5'>Upload disabled</div>
      </Wrapper>
    );

  if (!currFile && !uploaded)
    return label ? (
      <Wrapper maxSize={maxSize} types={types}>
        <div className='text-lg font-semibold mt-5'>
          {label.split(" ")[0]} {label.substr(label.indexOf(" ") + 1)}
        </div>
      </Wrapper>
    ) : (
      <Wrapper maxSize={maxSize} types={types}>
        <div className='text-lg font-semibold mt-5'>
          Click to upload a file or drag and drop it here
        </div>
      </Wrapper>
    );

  return (
    <Wrapper maxSize={maxSize} types={types}>
      <div className='text-lg font-semibold mt-5'>
        <span>Uploaded Successfully! Upload another?</span>
      </div>
    </Wrapper>
  );
};

const Wrapper = ({
  children,
  maxSize,
  types,
}: {
  children: React.ReactNode;
  maxSize?: number;
  types?: string[];
}) => {
  const prepareTypes = types?.map((type) => type.toUpperCase()).join(", ");

  return (
    <div className='flex flex-col items-center'>
      <Upload2Icon style={{ width: 20 }} />
      {children}{" "}
      <div className='text-sm text-mid-neutral-1 mt-5'>
        {maxSize && <span>{`Up to ${maxSize}MB in size`}</span>}
        {types && <span className='ml-1'>{prepareTypes}</span>}
      </div>
    </div>
  );
};

export default Description;
